import { StringToBool } from "../utils/StringToBool";
import { QXMLObject } from "./QXMLObject";

export class QAccessRecord extends QXMLObject {
  constructor() {
    super();
    this.fUserID = false;
    this.fAllowAccess = false;
    this.fDivAccessList = null;
    this.fDeptFilterList = null;
    //this.fFieldFilterList = null;
  }

  InitAccessRecord() {
    this.SetXMLElementName("accessrec");
  }

  Clone() {
    var c = new QAccessRecord();
    c.InitAccessRecord();
    c.fUserID = this.fUserID;
    c.fAllowAccess = this.fAllowAccess;
    c.fDivAccessList = this.fDivAccessList.slice();
    c.fDeptFilterList = this.fDeptFilterList.slice();

    return c;
  }

  GetUserID() {
    return this.fUserID;
  }

  SetUserID(userID) {
    this.fUserID = userID;
  }

  GetAllowAccess() {
    return this.fAllowAccess;
  }

  SetAllowAccess(allowAccess) {
    this.fAllowAccess = allowAccess;
  }

  GetDivFilterList() {
    return this.fDivAccessList;
  }

  GetIndexDiv(index) {
    return this.fDivAccessList[index];
  }

  GetIndexDept(index) {
    return this.fDeptFilterList[index];
  }

  IsListOpen(theList) {
    if (theList == null || theList.length == 0) return false;

    var firstElement = theList[0];
    var openList = firstElement == "*";
    return openList;
  }

  HandleOpenList(objList, objName) {
    if (objName == null) return true;

    var listLower = objList.join("|").toLowerCase().split("|");
    objName = "!" + objName;
    objName = objName.toLowerCase();
    var index = listLower.indexOf(objName);
    if (index == -1) return true;

    return false;
  }

  IncludeElement(theList, theElement) {
    if (this.IsListOpen(theList)) return this.HandleOpenList(theList, theElement);

    if (theElement == null) return false;

    theElement = theElement.toLowerCase();

    // This could be a problem for certain languages...
    var listLower = theList.join("|").toLowerCase().split("|");
    var index = listLower.indexOf(theElement);
    return index != -1;
  }

  SetDivFilterList(filterList) {
    this.fDivAccessList = filterList;
  }

  SetDeptFilterList(filterList) {
    this.fDeptFilterList = filterList;
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("allow", this.fAllowAccess, stream);
    this.OutputSimpleElement("user", this.fUserID, stream);

    if (this.fDivAccessList) {
      var divList = this.fDivAccessList.join("|");
      this.OutputSimpleElement("div", divList, stream);
    }
    if (this.fDeptFilterList) {
      var deptList = this.fDeptFilterList.join("|");
      this.OutputSimpleElement("dept", deptList, stream);
    }
  }

  LoadSubElements(objTree) {
    this.fUserID = objTree.GetValueForChild("user", false);
    var allowAccess = objTree.GetValueForChild("allow", false);
    this.fAllowAccess = StringToBool(allowAccess);
    var divList = objTree.GetValueForChild("div", false);
    if (divList) this.fDivAccessList = divList.split("|");
    else this.fDivAccessList = new Array();

    var deptList = objTree.GetValueForChild("dept", false);
    if (deptList) this.fDeptFilterList = deptList.split("|");
    else this.fDeptFilterList = new Array();
  }

  GetDeptFilterList() {
    return this.fDeptAccessList;
  }
}
